import './style.scss'

import * as loader from './js/loader.js';

import Swiper from 'swiper';
import { Autoplay, Navigation, Keyboard, FreeMode } from 'swiper/modules';

const swiper = new Swiper('.swiper-container', {
    modules: [Autoplay, Navigation, Keyboard, FreeMode],
    slidesPerView: 'auto',
    freeMode: true,
    grabCursor: true,

    loop: true,
    spaceBetween: -1,

    keyboard: {
        enabled: true,
        onlyInViewport: false,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },

    autoplay: {
        enabled: true,
        delay: 0,
        disableOnInteraction: false,
    },
    speed: 5000,
});


import * as gsap from './js/gsap.js';

import * as scrollTrigger from './js/scrollTrigger.js';

import LocomotiveScroll from 'locomotive-scroll';

const scroll = new LocomotiveScroll({
    el: document.querySelector("[data-scroll-container]"),
    smooth: true,
    tablet: { smooth: true },
    smartphone: { smooth: true }
});

import * as intersectionObserver from './js/intersectionObserver.js';


import * as gsapTransitions from './js/gsapTransitions.js';

import * as cursor from './js/cursor.js';
import * as rightClick from './js/rightClick';


